import axios from "axios";

export function getCategories() {
  let url = process.env.REACT_APP_BASE_URL + `api/v1/categories`;
  const bannerToken =localStorage.getItem("rfis");
  return axios.get(url, {
    headers: {
      rf_token_header123_k: bannerToken,
      "Content-Type": "application/json",
    },
  });
}

export async function getSubCategoriesByParentCategory(id, lang) {
 
  const bannerToken =localStorage.getItem("rfis");
  let url =
    process.env.REACT_APP_BASE_URL +
    `api/v1/subcategories/subcategory/${id}`;
  return axios.get(url, {
    headers: {
      rf_token_header123_k: bannerToken,
      "Content-Type": "application/json",
    },
  });
}

export async function getVideos(subCategory, language, category, options = {}) {
  const bannerToken = localStorage.getItem("rfis");
  const { categoryId, subCategoryId, limit = 500 } = options;
  const params = new URLSearchParams();

  if (categoryId) {
    params.set("categoryId", String(categoryId));
  } else if (category) {
    params.set("category", category);
  }

  if (subCategoryId) {
    params.set("subCategoryId", String(subCategoryId));
  } else if (subCategory) {
    params.set("subCategory", subCategory);
  }

  if (language) {
    params.set("language", language);
    params.set("language_id", language);
  }

  params.set("limit", String(limit));

  const url = `${process.env.REACT_APP_BASE_URL}api/v1/videos/?${params.toString()}`;
  return axios.get(url, {
    headers: {
      rf_token_header123_k: bannerToken,
      "Content-Type": "application/json",
    },
  });
}
export const languages = [
  { id: 1, langCode: "en", name: "English", lang: "English" },
  { id: 2, langCode: "hi", name: "Hindi", lang: "हिंदी" },
  { id: 3, langCode: "ta", name: "Tamil", lang: "தமிழ்" },
  { id: 4, langCode: "gu", name: "Gujarati", lang: "ગુજરાતી" },
  { id: 5, langCode: "ben", name: "Bengali", lang: "বাংলা" },
  { id: 6, langCode: "ma", name: "Marathi", lang: "मराठी" },
  { id: 7, langCode: "kan", name: "Kannada", lang: "ಕನ್ನಡ" },
  { id: 8, langCode: "tel", name: "Telugu", lang: "తెలుగు" },
  { id: 9, langCode: "ori", name: "Odia", lang: "ଓଡିଆ" },
  { id: 10, langCode: "mal", name: "Malayalam", lang: "മലയാളം" },
  { id: 11, langCode: "pa", name: "Punjabi", lang: "ਪੰਜਾਬੀ" },
];
